//components
import React from "react";
import ShowSingleInvites from "./ShowSingleInvites/ShowSingleInvites";

//styles
import "./PendingInvites.scss";
import "../../../Resources/Styles/fonts.scss";

//constants
import { Strings } from "../../../Resources/Strings/i18n";

function PendingInvites(props) {
  let { invites = [] } = props.userList || {};

  let monitored_users = [...invites.monitored_users];
  let monitoring_users = [...invites.monitoring_users];

  let careGiverInvite = monitored_users.map((user) => {
    return { ...user, type: Strings("Caregiver") };
  });
  let lovedOneInvite = monitoring_users.map((user) => {
    return { ...user, type: Strings("Senior") };
  });

  const allInvites = careGiverInvite.concat(lovedOneInvite);

  return allInvites.length ? (
    <div className="PendingInvites">
      <p className="heading">{Strings("PendingAccessRequests")}</p>

      <div className="PendingInvites_Content">
        {allInvites.map((user, index) => (
          <ShowSingleInvites
            key={index}
            inviteData={user}
            acceptDeclineHandler={props.inviteHandler}
          />
        ))}
      </div>
    </div>
  ) : null;
}

export default PendingInvites;
